import { Grid, Checkbox } from '@mui/material';

import { useState } from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';
import ModalEle from 'common/components/Modal/ModalEle';
import { toSentenceCase } from 'common/utils/utilFunctions';

import { IComplianceAcceptanceModal } from 'features/HorizonScanning/api/type-def';
import { horizonComplianceMsg } from 'features/HorizonScanning/HorizonScanConstants';

import styles from './ComplianceAcceptanceModal.module.scss';

const { textBoxColor } = styles;

const ComplianceAcceptanceModal = (props: IComplianceAcceptanceModal) => {
	const { openModal, handleClose, handleSubmit } = props;

	const [Checklist, setCheckList] = useState<boolean>(false);

	const handleModalClose = () => {
		handleClose();
	};

	const handleSave = () => {
		handleSubmit();
	};

	const handleCheckBox = (event: React.SyntheticEvent) => {
		setCheckList((event.target as HTMLInputElement).checked);
	};

	return (
		<ModalEle open={openModal} handleClose={handleModalClose}>
			<Grid container xs={12} lg={12} sm={12} md={12} direction="row">
				<Grid
					container
					item
					direction="row"
					xs={12}
					lg={12}
					sm={12}
					md={12}
					mt={2}
				>
					<Grid item xs={12} lg={12} sm={12} md={12}>
						{toSentenceCase('Accept Compliance')}{' '}
						<span className={styles['add-control-test-step-title-error']}>
							*
						</span>
					</Grid>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['checkbox-container']}
					>
						<span>
							<Checkbox
								data-testid="accept-checkbox"
								size="small"
								checked={Checklist}
								onChange={(event) => handleCheckBox(event)}
								sx={{
									'&.Mui-checked': {
										color: textBoxColor,
									},
									'&.MuiCheckbox-root': {
										padding: '0',
									},
								}}
								className={styles['checkbox-style']}
								disableRipple
							/>
						</span>
						<span className={styles['text-wrapper']}>
							{horizonComplianceMsg}
						</span>
					</Grid>
					<Grid
						item
						xs={12}
						lg={12}
						sm={12}
						md={12}
						className={styles['add-control-test-step-btngrp']}
					>
						<ButtonComp
							btnType="secondary"
							clickHandler={handleModalClose}
							data-testid="addtestmoal-cancel"
						>
							Cancel
						</ButtonComp>
						<ButtonComp
							btnType="primary"
							clickHandler={handleSave}
							disabled={!Checklist}
							data-testid="addtestmodal-save"
						>
							Accept
						</ButtonComp>
					</Grid>
				</Grid>
			</Grid>
		</ModalEle>
	);
};

export default ComplianceAcceptanceModal;
